import { ServerMarketerAccess } from '../../../typings/marketers';

export const UPDATE_INTERNAL_MARKETER_PRODUCT_ACCESS = 'UPDATE_INTERNAL_MARKETER_PRODUCT_ACCESS';
export type UPDATE_INTERNAL_MARKETER_PRODUCT_ACCESS = typeof UPDATE_INTERNAL_MARKETER_PRODUCT_ACCESS;

export interface UpdateInternalMarketerProductAccess {
    type: UPDATE_INTERNAL_MARKETER_PRODUCT_ACCESS;
    productId: string;
    accessType: ServerMarketerAccess;
    placeIds: number[];
}

export function updateInternalMarketerProductAccessAction(
    productId: string,
    accessType: ServerMarketerAccess,
    placeIds: number[]
): UpdateInternalMarketerProductAccess {
    return {
        type: UPDATE_INTERNAL_MARKETER_PRODUCT_ACCESS,
        productId,
        accessType,
        placeIds
    };
}
